import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../lib/auth";
import { useI18n } from "../lib/i18n";
import ListingCard from "../components/ListingCard";
import { Plus, UserCog } from "lucide-react";

export default function Dashboard() {
  const { user, loading } = useAuth();
  const { t } = useI18n();
  const nav = useNavigate();
  const [mine, setMine] = useState([]);

  useEffect(() => {
    if (loading) return;
    if (!user) { nav("/login"); return; }
    api.get(`/listings?user_id=${user.id}`).then(r => setMine(r.data)).catch(() => setMine([]));
  }, [user, loading, nav]);

  if (loading || !user) return null;

  return (
    <div data-testid="dashboard-page" className="pt-24 pb-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <div className="overline text-[#143122]">{t("nav_dashboard")}</div>
            <h1 className="mt-2 font-serif-display text-4xl md:text-5xl text-[#143122]">
              {t("welcome_back")}, {user.name.split(" ")[0]}
            </h1>
            <div className="mt-2 text-sm text-[#1A1F1C]/70">
              <span className="kav-chip">{t(`role_${user.role}`)}</span>
              {user.location && <span className="ml-2 text-[#1A1F1C]/60">{user.location}</span>}
            </div>
          </div>
          <div className="flex gap-3 flex-wrap">
            <button data-testid="dashboard-profile-btn" onClick={() => nav(`/users/${user.id}`)} className="kav-btn-secondary inline-flex items-center gap-2">
              <UserCog size={16} strokeWidth={1.75} /> {t("view_my_profile")}
            </button>
            <button data-testid="dashboard-favorites-btn" onClick={() => nav("/favorites")} className="kav-btn-secondary">
              {t("favorites")}
            </button>
            <button data-testid="dashboard-new-btn" onClick={() => nav("/new")} className="kav-btn-primary">
              <Plus size={16} strokeWidth={1.75} /> {t("create_listing")}
            </button>
          </div>
        </div>

        <div className="mt-12">
          <div className="overline text-[#143122]">{t("my_listings")}</div>
          <h2 className="mt-2 font-serif-display text-2xl text-[#1A1F1C]">{t("my_listings")}</h2>
          <div className="mt-6">
            {mine.length === 0 ? (
              <div className="text-sm text-[#1A1F1C]/60 border border-dashed border-[#E6E2D8] rounded-lg py-16 text-center">
                No listings yet. <button onClick={() => nav("/new")} className="underline text-[#143122]">Create your first one →</button>
              </div>
            ) : (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                {mine.map((l, i) => <ListingCard key={l.id} listing={l} index={i} />)}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
